// extracted by mini-css-extract-plugin
module.exports = {"group":"link-group_group__hJJkB","item":"link-group_item__UdasS"};